import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import {
  betAndFancyLocksCricketAPI,
  getAdminPlExposureCricketAPI,
  getBetActiveDeactiveCricketAPI,
  getClientBetsCricketAPI,
  getCricketEventDetailsAPI,
  getCricketOddsByMatchIdAPI,
  getSettledFancyAPI,
} from "../service/cricket";
import {
  getLiveStreamingUrlAPI,
  getSportsScoreAPI,
} from "../service/AuthService";
import moment from "moment";
import toast from "react-hot-toast";
import BookMakersBook from "./components/BookMakerBook";
import ViewMoreBet from "./components/ViewMoreBet";
import { useQuery } from "react-query";
import ReactSelect from "react-select";


export default function ViewSessionReport() {
  const [clients, setClients] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [clientBets, setClientBets] = useState([]);
  const [betStatus, setBetStatus] = useState("MATCHED");
  const [isFancy, setIsFancy] = useState(true);
  const [totalAmount, setTotalAmount] = useState(0);
  const [payload, setPayload] = useState({});
  const [showDisclosure, setShowDisclosure] = useState(false);
  const [bets, setBets] = useState([]);
  const [selectedClient, setSelectedClient] = useState(null);

  const params = useParams();

  var gameType = "cricket";
  var eventId = params?.id;
  var gameSettings = useSelector(
    (state) => state.gameData[gameType + "Settings"]
  );
  if (gameSettings && gameSettings[eventId]) {
    gameSettings = gameSettings[eventId];
  }

  const getClientBets = async (
    betStatus_,
    username,
    fancyTypes,
    filterWithoutCall = false
  ) => {
    if (filterWithoutCall) {
      if (username == "false" || fancyTypes == "false") {
        setClientBets(bets);
      } else {
        if (fancyTypes || username) {
          let bets_ = [...bets.bets];
          if (username) {
            bets_ = bets_.filter((item) => item.userName === username);
          }
          if (fancyTypes) {
            bets_ = bets_.filter((item) => item.runnerName === fancyTypes);
          }

          setClientBets({
            ...clientBets,
            bets: bets_,
          });
        }
      }
    } else {
      const { response } = await getClientBetsCricketAPI(
        eventId,
        isFancy,
        betStatus_ ? betStatus_ : betStatus
      );
      if (response) {
        setBets(response);
        setClients(
          Array.from(new Set(response?.bets?.map((item) => item?.userName)))
        );
        setSessions(
          Array.from(new Set(response?.bets?.map((item) => item?.runnerName)))
        );

        if (fancyTypes || username) {
          let bets_ = response;
          if (username) {
            bets_.bets = response.bets.filter(
              (item) => item.userName === username
            );
          }
          if (fancyTypes) {
            bets_.bets = response.bets.filter(
              (item) => item.runnerName === fancyTypes
            );
          }
          setClientBets(bets_);
        } else {
          setClientBets(response);
        }

        const totalAmount = response?.bets?.reduce(
          (total, item) => total + item.amount,
          0
        );

        setTotalAmount(totalAmount);
      }
    }
  };

  useEffect(() => {
    if (!payload.client || payload.client === 'All') {
      getClientBets();
    }
  }, [selectedClient]);

  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Session Bet Details </h1>
            </div>
            <div className="col-sm-6">
              <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Home</a>
                </li>
                <li className="breadcrumb-item active">Session Bet Details</li>
              </ol>
            </div>
          </div>
        </div>
        {/* /.container-fluid */}
      </section>
      <section className="content">
        <div className="container-fluid bg-white">
          <div className="row">
            <div className="col-12">
              {/* /.card */}
              <div className="card">
                <form
                  action="/game/i/2048/viewSessionReport"
                  id="myForm"
                  method="post"
                >
                  <div className="card-header ">
                    <div className="form-row">
                      <table
                        className="table table-bordered table-striped"
                        data-select2-id={6}
                      >
                        <thead className="text-bold" data-select2-id={5}>
                          <tr>
                            <th>Client</th>
                            <th
                              className="col-lg-4"
                              style={{ minWidth: 240 }}
                              data-select2-id={4}
                            >
                              <ReactSelect
                                id="name"
                                placeholder="Select Client"
                                name="client"
                                options={[
                                  { value: 'All', label: 'All', Select: true },
                                  ...(clients?.map((item, index) => ({
                                    value: item,
                                    label: item,
                                  })) || [])
                                ]}
                                onChange={(e) => {
                                  const selectedValue = e?.value;
                                  if (selectedValue === 'All') {
                                    setPayload({});
                                    setClientBets(bets);
                                    setSelectedClient(null);
                                  } else {
                                    setPayload({
                                      ...payload,
                                      client: selectedValue,
                                    });
                                    setSelectedClient(selectedValue);
                                    let filteredBets = { ...bets };
                                    if (selectedValue) {
                                      filteredBets.bets = bets.bets.filter(item => item.userName === selectedValue);
                                    }
                                    setClientBets(filteredBets);
                                  }
                                }}
                                value={payload.client ? {
                                  value: payload.client,
                                  label: payload.client
                                } : { value: 'All', label: 'All' }}
                              />
                            </th>
                            <th />
                            <th>Declare @ {showDisclosure ? clientBets?.bets?.[0]?.winner : ''}</th>
                          </tr>
                          <tr>
                            <th>Session</th>
                            <th className="col-lg-4" style={{ minWidth: 240 }}>
                              <ReactSelect
                                id="name"
                                placeholder="Select Sessions"
                                name="client"
                                options={[
                                  { value: 'All', label: 'All', Select: true },
                                  ...(sessions?.map((item, index) => ({
                                    value: item,
                                    label: item,
                                  })) || [])
                                ]}
                                // options={sessions.map((item) => ({
                                //   value: item,
                                //   label: item,
                                // }))}
                                onChange={(e) =>
                                  setPayload({
                                    ...payload,
                                    session: e.value,
                                  })
                                }
                              />
                            </th>
                            <th>
                              <button
                                onClick={() => {
                                  getClientBets(betStatus, payload.client, payload.session);
                                  setShowDisclosure(true);
                                }
                                }

                                type="button"
                                className="btn btn-primary"
                              >
                                View
                              </button>
                            </th>
                            <th className="">{showDisclosure ? clientBets?.bets?.[0]?.winner : ''}</th>
                          </tr>
                        </thead>
                      </table>
                    </div>
                  </div>

                  <div className="card-body">
                    <div>
                      <div className="row">
                        <div className="col-md-12">
                          <table className="table table-striped table-bordered">
                            <thead>
                              <tr>
                                <th>#</th>
                                <th>Client</th>
                                <th>Session</th>
                                <th>Rate</th>
                                <th>Amount</th>
                                <th>Runs</th>
                                <th style={{ width: 40 }}>Mode</th>
                                <th>Yes</th>
                                <th>No</th>
                                <th>DEC</th>

                                <th>Date &amp; Time</th>
                              </tr>
                              <tr>
                                <th
                                  colSpan={3}
                                  className="text-indigo text-lg text-center"
                                >
                                  Total Amount
                                </th>
                                <th
                                  colSpan={4}
                                  className={`text-lg text-center ${totalAmount < 0 ? "text-red" : "text-blue"
                                    }`}
                                >
                                  {totalAmount}
                                </th>

                                <th
                                  colSpan={3}
                                  className={`text-lg text-center ${totalAmount < 0 ? "text-red" : "text-blue"
                                    }`}
                                >
                                  {totalAmount}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {clientBets?.bets?.map((item, index) => (
                                <>
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>{item.userName}</td>
                                    <td>{item.runnerName}</td>
                                    <td>{item.rate}</td>
                                    <td>{item.amount}</td>
                                    <td>{item.run}</td>
                                    <td>
                                      {item.back == false ? <>No</> : <>Yes</>}
                                    </td>
                                    {item?.upperLineExposure?.map((item) => (
                                      <td>{item?.exposure}</td>
                                    ))}

                                    {/* <td>
                                      {item.winner
                                        ? item.winner
                                        : item.plusMinus === 0 && item.clientPlusMinus === 0
                                          ? <span><b>ABANDONED</b></span>
                                          : <span><b>PENDING</b></span>
                                      }
                                    </td> */}

                                    <td>
                                      {item.winner || <span><b>PENDING</b></span>}
                                    </td>

                                    <td>
                                      {moment(item?.placeDate + "Z").format(
                                        "DD-MM-YYYY HH:mm:ss"
                                      )}
                                    </td>
                                  </tr>
                                </>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* /.card-body */}
                </form>
              </div>
              {/* /.card */}
            </div>
            {/* /.col */}
          </div>
          {/* /.row */}
        </div>
        {/* /.container-fluid */}
      </section>
    </div>
  );
}
